/* Warenkorb-Booster (2026-11-03)
   1) "Passt dazu" upsell: one-click add ([data-cbu-add]) via /cart/add.js.
   2) Gratis-Sticker: add button ([data-fsb-gift-add]) and automatic removal of the
      gift when the cart drops below the threshold (it would otherwise be charged).
   After every change the cart drawer is re-rendered with the theme's own
   CartDrawer.renderContents(); on the cart page the page is reloaded. */
(function () {
  if (window.__cartBoostersInit) return;
  window.__cartBoostersInit = true;

  var busy = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function isCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  function apply(state) {
    if (isCartPage()) {
      window.location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections && state.sections['cart-drawer']) {
      drawer.renderContents(state);
    } else {
      window.location.href = root() + 'cart';
      return;
    }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-boosters', cartData: state });
      }
    } catch (e) {}
  }

  function post(path, payload) {
    if (!isCartPage()) {
      payload.sections = 'cart-drawer';
      payload.sections_url = window.location.pathname;
    }
    return fetch(root() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    });
  }

  function addVariant(variantId, btn, box) {
    if (busy) return;
    busy = true;
    var label = btn && btn.querySelector('[data-cbu-label]');
    var oldText = label ? label.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (label && box) label.textContent = box.getAttribute('data-cbu-text-adding') || oldText;
    }
    post('cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      .then(function (state) {
        busy = false;
        apply(state);
      })
      .catch(function (err) {
        busy = false;
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (label) label.textContent = oldText;
        }
        var errEl = box && box.querySelector('[data-cbu-error]');
        if (errEl) {
          errEl.textContent = (err && err.description) || (box.getAttribute('data-cbu-text-error') || '');
          errEl.hidden = false;
        }
      });
  }

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    post('cart/change.js', { id: key, quantity: quantity })
      .then(function (state) {
        busy = false;
        apply(state);
      })
      .catch(function () {
        busy = false;
      });
  }

  document.addEventListener('click', function (event) {
    var add = event.target.closest('[data-cbu-add]');
    if (add) {
      event.preventDefault();
      addVariant(parseInt(add.getAttribute('data-cbu-add'), 10), add, add.closest('[data-cbu]'));
      return;
    }
    var gift = event.target.closest('[data-fsb-gift-add]');
    if (gift) {
      event.preventDefault();
      var giftEl = gift.closest('[data-fsb-gift]');
      var v = giftEl && parseInt(giftEl.getAttribute('data-gift-variant'), 10);
      if (v) {
        gift.disabled = true;
        addVariant(v, null, null);
      }
    }
  });

  document.addEventListener('fsb:rendered', function (event) {
    var cart = event.detail && event.detail.cart;
    var giftEl = document.querySelector('[data-fsb-gift][data-gift-variant]:not([data-gift-variant=""])');
    if (!cart || !giftEl || busy || typeof window.FreeShippingBar_giftState !== 'function') return;
    var st = window.FreeShippingBar_giftState(giftEl, cart);
    if (!st.variant || !st.key || !st.threshold) return;
    if (st.remaining > 0) {
      changeLine(st.key, 0);
    } else if (st.qty > 1) {
      changeLine(st.key, 1);
    }
  });
})();
